import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import { testBrowserType } from '../_utils/testBrowserType';
import { GapContext } from './row';
var Col = function Col(props) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var _a = getCompProps('Col', userDefaultProps, props),
    xs = _a.xs,
    sm = _a.sm,
    md = _a.md,
    lg = _a.lg,
    xl = _a.xl,
    flex = _a.flex,
    span = _a.span,
    pull = _a.pull,
    push = _a.push,
    style = _a.style,
    order = _a.order,
    offset = _a.offset,
    children = _a.children,
    className = _a.className,
    customPrefixcls = _a.prefixCls,
    others = __rest(_a, ["xs", "sm", "md", "lg", "xl", "flex", "span", "pull", "push", "style", "order", "offset", "children", "className", "prefixCls"]);
  var rowGroup = useContext(GapContext);
  var mergedWinWidth = rowGroup.winWidth;
  var gap = rowGroup.gap;
  // 浏览器名称
  var isSogouOrIE = testBrowserType(/^sogou/i, 0) || /Trident|MSIE/.test(navigator.userAgent);
  var colGapStyle = {
    padding: "0 ".concat(gap.h / 2, "px")
  };
  if (isSogouOrIE && gap.v) colGapStyle.marginBottom = gap.v;
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'col', customPrefixcls);
  var columns = 24;
  var base = {
    span: span,
    pull: pull,
    push: push,
    offset: offset,
    order: order
  };
  if (xs && mergedWinWidth > 0) {
    if (xs.constructor === Number) base.span = xs;
    if (xs.constructor === Object) base = _extends(_extends({}, base), xs);
  }
  if (sm && mergedWinWidth >= 600) {
    if (sm.constructor === Number) base.span = sm;
    if (sm.constructor === Object) base = _extends(_extends({}, base), sm);
  }
  if (md && mergedWinWidth >= 1024) {
    if (md.constructor === Number) base.span = md;
    if (md.constructor === Object) base = _extends(_extends({}, base), md);
  }
  if (lg && mergedWinWidth >= 1280) {
    if (lg.constructor === Number) base.span = lg;
    if (lg.constructor === Object) base = _extends(_extends({}, base), lg);
  }
  if (xl && mergedWinWidth >= 1920) {
    if (xl.constructor === Number) base.span = xl;
    if (xl.constructor === Object) base = _extends(_extends({}, base), xl);
  }
  var width = base.span ? base.span / columns * 100 + '%' : '100%';
  var flexstr = "0 0 ".concat(width);
  if (flex) {
    if (flex.constructor === Number) {
      var _context;
      flexstr = _concatInstanceProperty(_context = "".concat(flex, " ")).call(_context, flex, " auto");
    }
    if (flex.constructor === String) {
      var flexArr = flex.split(' ');
      if (flexArr.length === 1 && /px/.test(flexArr[0])) {
        flexstr = "0 0 ".concat(flexArr[0]);
      } else {
        flexstr = flex;
      }
    }
  }
  var styleString = _extends(_extends({
    flex: flexstr,
    maxWidth: width,
    order: base.order,
    left: base.push && base.push / columns * 100 + '%',
    right: base.pull && base.pull / columns * 100 + '%',
    marginLeft: base.offset && base.offset / columns * 100 + '%'
  }, colGapStyle), style);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(prefixCls, className),
    style: styleString
  }, others), children);
};
Col.displayName = 'Col';
export default Col;